import { render } from "./StockPage.vue?vue&type=template&id=5c0c43bc"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__